var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcHomePayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.745,
    height: 33.084,
    viewBox: "0 0 45.745 33.084",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2s7kxuvea",
    x1: 0.5,
    y1: -0.105,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "vrxthm6vhb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5826",
    style: {
      fill: "url(#b2s7kxuvea)"
    },
    d: "M0 0h45.745v33.084H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2952"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2477",
    transform: "translate(-756 -27.936)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5827",
    width: 36.988,
    height: 13.16,
    rx: 6.58,
    transform: "translate(764.756 28.84)",
    style: {
      fill: "#fff4aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2928"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2929"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2928",
    style: {
      clipPath: "url(#vrxthm6vhb)"
    },
    transform: "translate(756 27.935)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4120",
    d: "M36.967 35.533v10.742a2.281 2.281 0 0 1-2.279 2.279H4.84a2.281 2.281 0 0 1-2.279-2.279V27.763a2.281 2.281 0 0 1 2.279-2.279h25.217v-2.561H4.84A4.845 4.845 0 0 0 0 27.763v18.512a4.845 4.845 0 0 0 4.84 4.84h29.848a4.845 4.845 0 0 0 4.84-4.84V35.349a6.645 6.645 0 0 1-2.561.184",
    transform: "translate(0 -18.031)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4121",
    d: "M27.609 123.292h-4.851a1.281 1.281 0 0 1 0-2.561h4.852a1.281 1.281 0 0 1 0 2.561",
    transform: "translate(-16.893 -94.965)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4122",
    d: "M118.548 123.292h-.057a1.281 1.281 0 1 1 0-2.561h.057a1.281 1.281 0 0 1 0 2.561",
    transform: "translate(-92.196 -94.965)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4123",
    d: "M137.161 123.711h-.061a1.281 1.281 0 0 1 0-2.561h.057a1.281 1.281 0 1 1 0 2.561",
    transform: "translate(-106.836 -95.294)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4124",
    d: "M156.162 123.711h-.062a1.281 1.281 0 1 1 0-2.561h.057a1.281 1.281 0 0 1 0 2.561",
    transform: "translate(-121.781 -95.294)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4125",
    d: "M161.62 33.494h-.02a1.28 1.28 0 0 1-.938-.429l-2.134-2.4a1.28 1.28 0 1 1 1.913-1.7l1.206 1.355 2.617-2.773a1.28 1.28 0 1 1 1.862 1.758l-3.576 3.789a1.28 1.28 0 0 1-.931.4",
    transform: "translate(-124.441 -21.35)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4126",
    d: "M34.877 48.269H6v2.561h29.643a8.514 8.514 0 0 1-.766-2.561",
    transform: "translate(-4.72 -37.967)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4127",
    d: "M37.434 72.875c-.083-.071-.161-.143-.241-.216H5.425v2.561h37.212v-.54a6.913 6.913 0 0 1-5.2-1.805",
    transform: "translate(-4.267 -57.152)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4128",
    d: "M156.445 6.937a22.778 22.778 0 0 1-.023 3.163 8.159 8.159 0 0 1-5.352 6.974 6.783 6.783 0 0 1-7.135-1.352 8.556 8.556 0 0 1-3.105-6.7c-.014-1.546.007-3.093-.007-4.639a1.461 1.461 0 0 1 .948-1.482q3.039-1.343 6.068-2.709a1.928 1.928 0 0 1 1.667 0q3.016 1.355 6.039 2.694a1.471 1.471 0 0 1 .968 1.5c-.018.849 0 1.7 0 2.548h-.064m-13.005.4v1.568a6.222 6.222 0 0 0 2.1 4.773 4.537 4.537 0 0 0 5.04.787 5.811 5.811 0 0 0 3.3-5.116c.093-1.355.016-2.721.026-4.081a.339.339 0 0 0-.238-.365c-1.6-.706-3.192-1.423-4.793-2.125a.578.578 0 0 0-.417 0c-1.59.7-3.174 1.412-4.764 2.111a.377.377 0 0 0-.257.418c.014.675.005 1.35.005 2.025",
    transform: "translate(-110.769)",
    style: {
      fill: "url(#b2s7kxuvea)"
    }
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcHomePayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-homePayment.7b4fa81235315dd5f823f2faee96d467.svg";